// Google Map Function
import greenZonesGeoJSON from './GeoJSON/green-zones.js';
import yellowZonesGeoJSON from './GeoJSON/yellow-zones.js';
import blueZonesGeoJSON from './GeoJSON/blue-zones.js';

navigator.sayswho = (function () {
  var ua = navigator.userAgent;
  var tem;
  var M =
    ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) ||
    [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return 'IE ' + (tem[1] || '');
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
  return M.join(' ');
})();

/**
 * Function check for touchscreen device
 * **/
function is_touch_enabled() {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}

/**
 * newShade function, convert hexColor to lighter or darker variant
 * @params hexColor, magnitude
 * @param hexColor - color in HEX format, type: string, default: ['#ffffff']
 * @param magnitude - amount of percentage to tint, lighter if > 0, darker if < 0, type: number
 * **/
window.disableCheckoutBtn = function disableCheckoutBtn() {
  const btn = document.getElementById('checkout-btn');
  btn.disabled = true;
  btn.classList.add('disabled-type');
};

window.enableCheckoutBtn = function enableCheckoutBtn() {
  const btn = document.getElementById('checkout-btn');
  btn.disabled = false;
  btn.classList.remove('disabled-type');
};

window.enableCheckoutRemoveZoneBtn = function enableCheckoutRemoveZoneBtn() {
  const btn = document.getElementById('checkout-btn');
  const orderZone = document.querySelector('.order__zone');
  btn.disabled = false;
  btn.classList.remove('disabled-type');

  if (orderZone) {
    orderZone.classList.add(
      '!opacity-0',
      '!transition',
      '!duration-300',
      '!ease-in-out'
    );
    setTimeout(function () {
      orderZone.classList.add('!hidden');
      orderZone.classList.remove(
        '!opacity-0',
        '!transition',
        '!duration-300',
        '!ease-in-out'
      );
    }, 400);
  }
};

// console.log(12345);

const newShade = (hexColor, magnitude) => {
  hexColor = hexColor.replace(`#`, ``);
  if (hexColor.length === 6) {
    const decimalColor = parseInt(hexColor, 16);
    let r = (decimalColor >> 16) + magnitude;
    r > 255 && (r = 255);
    r < 0 && (r = 0);
    let g = (decimalColor & 0x0000ff) + magnitude;
    g > 255 && (g = 255);
    g < 0 && (g = 0);
    let b = ((decimalColor >> 8) & 0x00ff) + magnitude;
    b > 255 && (b = 255);
    b < 0 && (b = 0);
    return `#${(g | (b << 8) | (r << 16)).toString(16)}`;
  } else {
    return hexColor;
  }
};

// Custom Popup content
function popupContent(data) {
  return `
        <div class="flex flex-col bg-white rounded-none">
            <h3 class="my-4 font-medium text-blue text-xl px-3">$${Number(
              data.price
            ).toLocaleString('en-GB')}</h3>
            <p class="mb-4 px-3 text-base text-blue">${data.location}</p>
            <img class="w-full h-auto" src="${data.image}" alt="">
        </div>
    `;
}

// Sort delivery zones points
function sortPointsForPolygon(points) {
  // Get the center (mean value) using reduce
  const center = points.reduce(
    (acc, { lat, lng }) => {
      acc.lat += lat / points.length;
      acc.lng += lng / points.length;
      return acc;
    },
    { lat: 0, lng: 0 }
  );

  // Add an angle property to each point using tan(angle) = y/x
  const angles = points.map(({ lat, lng }) => {
    return {
      lat,
      lng,
      angle: (Math.atan2(lng - center.lng, lat - center.lat) * 180) / Math.PI,
    };
  });

  // Sort your points by angle
  const sortByAngles = angles.sort((a, b) => a.angle - b.angle);

  // delete Angle Property
  sortByAngles.forEach((elem) => delete elem.angle);
  return sortByAngles;
}

// Parse GeoJSON to Normal appearance
function parseGeoJsonToLocations(geoJsonData) {
  const locations = geoJsonData.features.map((feature) => {
    const name = feature.properties.Name;
    const coordinates = feature.geometry.coordinates[0].map((coord) => ({
      lat: coord[1],
      lng: coord[0],
    }));
    return { name, coordinates };
  });
  return { name: geoJsonData.name, locations };
}

function initMapFunc(
  google,
  map,
  marker,
  json,
  defaultJson,
  zoom,
  defaultCenter
) {
  const mapID = 'DEMO_MAP_ID';
  const myStyles = [
    {
      featureType: 'poi',
      stylers: [{ visibility: 'off' }],
    },
  ];

  const mapStyles = [
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#d3d3d3',
        },
      ],
    },
    {
      featureType: 'transit',
      stylers: [
        {
          color: '#808080',
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#b3b3b3',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#ffffff',
        },
        {
          weight: 1.8,
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#d7d7d7',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#ebebeb',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry',
      stylers: [
        {
          color: '#a7a7a7',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#efefef',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#696969',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'labels.text.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#737373',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#d6d6d6',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {},
    {
      featureType: 'poi',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#dadada',
        },
      ],
    },
  ];

  if (json?.length === 0) return;

  map = new google.maps.Map(document.getElementById('map'), {
    center:
      defaultCenter ||
      new google.maps.LatLng(49.815691263639934, 24.01786260839841),
    zoom: +zoom,
    mapTypeControl: false,
    styles: mapStyles,
  });

  // const card = document.getElementById("pac-card");
  // const input = document.getElementById("postcode");

  // Bind the map's bounds (viewport) property to the autocomplete object,
  // so that the autocomplete requests use the current map bounds for the
  // bounds option in the request.
  // autocomplete.bindTo("bounds", map);

  if (defaultJson) {
    var latLngDefault = new google.maps.LatLng(
      defaultJson.lat,
      defaultJson.lng
    );

    // AdvancedMarker with colorPicker Logic
    /*const pinViewBackground = new google.maps.marker.PinView({
			borderColor: newShade(defaultJson.pinColor, -20),
			background: newShade(defaultJson.pinColor, 20),
			glyphColor: defaultJson.pinColor,
		});

		const marker = new google.maps.marker.AdvancedMarkerView({
			position: latLngDefault,
			map: map,
			title: defaultJson.title,
			content: pinViewBackground.element,
		});*/

    const pinIconHref =
      data.points_type_id === 1
        ? `${site_dir}/public/images/pins/pin-1.svg`
        : defaultJson.pinPath;

    const marker = new google.maps.Marker({
      position: latLngDefault,
      map: map,
      icon: `${pinIconHref}`,
      zIndex: data.points_type_id === 1 ? 9999 : 2,
    });
  }

  let markersArr = [];

  for (const key in json) {
    const data = json[key];

    var latLng = new google.maps.LatLng(data.lat, data.lng);

    /*const pinViewBackground = new google.maps.marker.PinView({
			borderColor: newShade(data.pinColor, -20),
			background: newShade(data.pinColor, 20),
			glyphColor: data.pinColor,
		});

		const marker = new google.maps.marker.AdvancedMarkerView({
			position: latLng,
			map: map,
			title: data.title,
			content: pinViewBackground.element,
		});*/

    const pinIconHref =
      data.points_type_id === 1
        ? `${site_dir}public/images/pins/pin-1.svg`
        : data.pinPath;

    const marker = new google.maps.Marker({
      position: latLng,
      map: map,
      icon: `${pinIconHref}`,
      zIndex: data.points_type_id === 1 ? 9999 : 2,
    });

    markersArr.push(marker);
  }

  return { map, markersArr };
}

function initDeliveryZonesFunc(google, map, geocoder, json, zoom, type) {
  const mapID = 'DEMO_MAP_ID';
  const mapStyles = [
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#d3d3d3',
        },
      ],
    },
    {
      featureType: 'transit',
      stylers: [
        {
          color: '#808080',
        },
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#b3b3b3',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#ffffff',
        },
        {
          weight: 1.8,
        },
      ],
    },
    {
      featureType: 'road.local',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#d7d7d7',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#ebebeb',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry',
      stylers: [
        {
          color: '#a7a7a7',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ffffff',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#efefef',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#696969',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'labels.text.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          color: '#737373',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#d6d6d6',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {},
    {
      featureType: 'poi',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#dadada',
        },
      ],
    },
  ];

  geocoder = new google.maps.Geocoder();

  var myLatlng = new google.maps.LatLng(
    json[0]?.lat ? json[0]?.lat : 49.815691263639934,
    json[0]?.lng ? json[0]?.lng : 24.01786260839841
  );

  map = new google.maps.Map(document.getElementById('map'), {
    center: myLatlng,
    zoom: +zoom,
    mapTypeControl: false,
    styles: mapStyles,
  });

  const marker = new google.maps.Marker({
    map,
    anchorPoint: new google.maps.Point(0, -29),
    // draggable: true,
  });

  const greenDeliveryArea = parseGeoJsonToLocations(greenZonesGeoJSON);
  const yellowDeliveryArea = parseGeoJsonToLocations(yellowZonesGeoJSON);
  const blueDeliveryArea = parseGeoJsonToLocations(blueZonesGeoJSON);

  const greenDeliveryPoligon = new google.maps.Polygon({
    paths: greenDeliveryArea.locations.map((loc) => loc.coordinates),
    strokeColor: '#242426',
    strokeOpacity: 0.2,
    strokeWeight: 1,
    fillColor: '#229F5B',
    fillOpacity: 0.5,
  });

  const blueDeliveryPoligon = new google.maps.Polygon({
    paths: blueDeliveryArea.locations.map((loc) => loc.coordinates),
    strokeColor: '#242426',
    strokeOpacity: 0.2,
    strokeWeight: 1,
    fillColor: '#1799BA',
    fillOpacity: 0.5,
  });

  const yellowDeliveryPoligon = new google.maps.Polygon({
    paths: yellowDeliveryArea.locations.map((loc) => loc.coordinates),
    strokeColor: '#242426',
    strokeOpacity: 0.2,
    strokeWeight: 1,
    fillColor: '#F7AD40',
    fillOpacity: 0.5,
  });

  greenDeliveryPoligon.setMap(map);
  yellowDeliveryPoligon.setMap(map);
  blueDeliveryPoligon.setMap(map);

  /*const bounds = new google.maps.LatLngBounds();

  greenDeliveryArea.locations.forEach((loc) => {
    loc.coordinates.forEach((coord) => {
      bounds.extend(coord);
    });
  });

  yellowDeliveryArea.locations.forEach((loc) => {
    loc.coordinates.forEach((coord) => {
      bounds.extend(coord);
    });
  });

  blueDeliveryArea.locations.forEach((loc) => {
    loc.coordinates.forEach((coord) => {
      bounds.extend(coord);
    });
  });

  map.fitBounds(bounds);*/

  /**
   * Comment out for now
   * Position google marker always in center of map when dragging
   * **/
  // google.maps.event.addListener(map, "drag", function () {
  // 	console.log(this.getCenter().lat(), this.getCenter().lng());
  // 	// marker.setPosition(this.getCenter());
  // });

  if (type === 'checkout') {
    checkoutLogicWithInputs(
      map,
      marker,
      greenDeliveryPoligon,
      yellowDeliveryPoligon,
      blueDeliveryPoligon
    );
  }
}

function hoverShowTrueMarker(data) {
  const locationsSection = document.getElementById('our-locations-section');
  if (locationsSection) {
    const searchResultsBox = document.getElementById('search_results_box');
    const locationsArr = searchResultsBox.querySelectorAll('.location-card');
    const latLngArr = [];

    let previousMarker = null;
    let previousIcon = null;

    locationsArr.forEach((location, index) => {
      const lat = Number(location.getAttribute('data-lat'));
      const lng = Number(location.getAttribute('data-lng'));

      latLngArr.push({ lat, lng });
      let trueMarker = null;

      for (let i = 0; i < json.length; i++) {
        if (
          Number(lat) === markersArr[i].getPosition().lat() &&
          Number(lng) === markersArr[i].getPosition().lng()
        ) {
          trueMarker = markersArr[i];
          break;
        }
      }

      function bindInfoWindow(marker, map, infoWindow, data) {
        const mapBlock = document.getElementById('map');

        let originalIcon = trueMarker.getIcon();
        let iconPath = originalIcon.substring(
          0,
          originalIcon.lastIndexOf('/') + 1
        );

        google.maps.event.addListener(marker, 'click', function () {
          if (previousMarker) {
            previousMarker.setIcon(previousIcon);
            previousMarker.zIndex = 2;
            previousMarker.setAnimation(null);
          }

          previousMarker = trueMarker;
          previousIcon = originalIcon;

          markersArr.forEach((mrk) => {
            mrk.setAnimation(null);
          });

          locationsArr.forEach((loc) => loc.classList.remove('active'));

          trueMarker.setIcon(`${iconPath}point-1-active.svg`);
          trueMarker.zIndex = 100;
          trueMarker.setAnimation(google.maps.Animation.BOUNCE);

          location.classList.add('active');
          scrollIntoView(location);
        });

        location.addEventListener('click', () => {
          if (previousMarker) {
            previousMarker.setIcon(previousIcon);
            previousMarker.zIndex = 2;
            previousMarker.setAnimation(null);
          }

          previousMarker = trueMarker;
          previousIcon = originalIcon;

          // Hover on Location block
          markersArr.forEach((mrk) => {
            mrk.setAnimation(null);
          });
          /*locationsArr.forEach((loc) => loc.classList.remove('hovered'));*/
          /*location.classList.add('hovered');*/

          map.panTo(new google.maps.LatLng(lat, lng));

          trueMarker.setIcon(`${iconPath}point-1-active.svg`);
          trueMarker.zIndex = 100;
          trueMarker.setAnimation(google.maps.Animation.BOUNCE);
        });

        /*location.addEventListener('mouseleave', () => {
          // Hover out Location block
          /!*locationsArr.forEach((loc) => loc.classList.remove('hovered'));*!/
          trueMarker.setIcon(originalIcon);
          trueMarker.setAnimation(null);
        });*/

        location.addEventListener('click', function () {
          if (is_touch_enabled()) {
            scrollIntoView(document.getElementById('map'));
          }
        });

        if (index === 0) {
          location.click();
        }
      }

      const infoWindow = new google.maps.InfoWindow();
      const infoWindowContent = document.getElementById('infowindow-content');
      infoWindow.setContent(infoWindowContent);
      bindInfoWindow(trueMarker, map, infoWindow, data[index]);
    });
  }
}

/**
 * Checkout logic with form inputs on '/checkout'
 * @param map - Google Maps API: Map
 * @param marker - Google Maps API: Marker
 * @param greenDeliveryPoligon - Polygon of Green Delivery Zone
 * @param yellowDeliveryPoligon - Polygon of Yellow Delivery Zone
 * @param blueDeliveryPoligon - Polygon of Red Delivery Zone
 * **/
function checkoutLogicWithInputs(
  map,
  marker,
  greenDeliveryPoligon,
  yellowDeliveryPoligon,
  blueDeliveryPoligon
) {
  const selectCityEl = document.querySelector('#city-select');
  let citySelect = null;

  if (selectCityEl) {
    console.log(selectCityEl)
    selectCityEl.classList.add('is-init');

    citySelect = new Choices(selectCityEl, {
      searchEnabled: true,
      itemSelectText: '',
      placeholder: true,
      allowHTML: true,
      sorter: (a, b) => 0,
      fuseOptions: {
        threshold: 0.3,
      },
      noResultsText: 'Нічого не знайдено',
    });

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const selectedOption = selectCityEl.querySelector('option[selected]');
          if (selectedOption) {
            if(selectedOption.value === 'other') {
              ifOtherFunc();
              setTimeout(function () {
                if(document.querySelector('#delivery_area_banner')) {
                  document.querySelector('#delivery_area_banner').classList.add('hidden');
                }
              }, 100)
            } else {
              elseOtherFunc();
              setTimeout(function () {
                if(document.querySelector('#delivery_area_banner')) {
                  document.querySelector('#delivery_area_banner').classList.remove('hidden');
                }
              }, 100)
            }
            /*console.log('Выбранное значение:', selectedOption.value);
            console.log('Текст:', selectedOption.textContent.trim());*/
          }
        }
      }
    });

    observer.observe(selectCityEl, {
      childList: true,
      subtree: true, // важно!
    });

    const choiceEl = selectCityEl.parentElement?.parentElement;

    let hasListenerBeenCalled = false;

    document.addEventListener('pointerdown', (event) => {
      const wasOpen = choiceEl.classList.contains('is-open');

      requestAnimationFrame(() => {
        const isNowClosed = !choiceEl.classList.contains('is-open');

        if (wasOpen && isNowClosed) {
          if (!hasListenerBeenCalled) {
            formInputsListener(citySelect);
            hasListenerBeenCalled = true;
          }
        }
      });
    });

    document.addEventListener('pointerdown', (event) => {
      if (choiceEl.classList.contains('is-open')) {
        hasListenerBeenCalled = false;
      }
    });
  } else {
    // console.error('Элемент #city-select не найден!');
  }

  /**
   * Get place from Google Maps API / Geolocation by inputs values in form
   * @param city - value of select #choices-select
   * @param street - value of input #street
   * @param house - value of input #house
   * @return place
   * **/
  async function getPlacePredictionsByInputs(city, street, house) {
    const fullInput = encodeURI(
      `місто ${city}, вулиця ${street}, будинок ${house}`
    );

    /*console.log('fullInput', fullInput);*/

    try {
      const response = await axios.post(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${fullInput}&key=${googleAPIKey}&region=UA&language=uk`
      );

      const place = response.data.results[0];

      validatePlacePrediction(place, city);
    } catch (e) {
      throw e;
    }
  }

  /**
   * Get place from Google Maps API / Geolocation by marker position
   * @param lat - latitude of a marker position
   * @param lng - longitude of a marker position
   * @return void
   * **/
  async function getPlacePredictionsByMarkerMove(lat, lng) {
    // https://maps.googleapis.com/maps/api/geocode/json?latlng=40.714224,-73.961452&key=YOUR_API_KEY
    try {
      const response = await axios.post(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${googleAPIKey}`
      );
      const place = response.data.results[0];

      validatePlacePrediction(place);
    } catch (e) {
      // console.log(e);
      throw e;
    }
  }

  /**
   * Validate Place received from Google Maps API / Geolocation
   * @param place
   * @return void
   * **/

  let cityNew = 'Львів';

  function validatePlacePrediction(place, city) {
    const locality = place?.address_components
      ?.find((component) => component.types.includes('locality'))
      ?.long_name.toLowerCase();

    // console.log("place", place);
    // console.log("locality", locality);
    // console.log("same locality?", locality === city.toLowerCase());

    if (
      !place ||
      !place.geometry ||
      !place.geometry.location ||
      locality !== city.toLowerCase()
    ) {
      cityNew = city;
      console.log(cityNew);
      // User entered the name of a Place that was not suggested and
      // pressed the Enter key, or the Place Details request failed.
      // Swal.fire({
      //   icon: 'error',
      //   title:
      //     'Перевірте правильність написання адреси, ми не можемо знайти її',
      //   confirmButtonText: 'Зрозуміло',
      // }).then((result) => {});

      marker.setVisible(false);
      disableCheckoutBtn();

      load('change-delivery-area', 'area=outside', 'location=' + city);

      // If the place has a geometry, then present it on a map.
      map.setCenter(
        new google.maps.LatLng(49.815691263639934, 24.01786260839841)
      );
      map.setZoom(11);
      return;
    }

    // If the place has a geometry, then present it on a map.
    map.setCenter(place.geometry.location);
    map.setZoom(13);

    // Set position of marker in center of place and make it visible.
    marker.setPosition(place.geometry.location);
    marker.setVisible(true);

    if (checkPointInsidePoly(place, greenDeliveryPoligon)) {
      enableCheckoutBtn();
      // console.log("area=green");
      load('change-delivery-area', 'area=green', 'location=' + city);
    } else if (checkPointInsidePoly(place, yellowDeliveryPoligon)) {
      enableCheckoutBtn();
      // console.log("area=yellow");
      load('change-delivery-area', 'area=yellow', 'location=' + city);
    } else if (checkPointInsidePoly(place, blueDeliveryPoligon)) {
      enableCheckoutBtn();
      // console.log("area=red");
      load('change-delivery-area', 'area=blue', 'location=' + city);
    }
  }

  /**
   * Search Place and Validate on Back logic
   * Fired every time one of inputs is changed
   * @param citySelect - select #choices-select [Choices.js]
   * @return void
   * **/
  let isAutoCompleteFlagStart = false;
  function formInputsListener(citySelect) {
    const city = citySelect.getValue(true);
    const street = document.getElementById('street').value;
    const house = document.getElementById('house').value;

    /*const normalizedStreet = street.toLowerCase().replace(/[.,]/g, '');

    if (isAutoCompleteFlagStart !== false) {
      if (normalizedStreet.includes(city.trim().toLowerCase())) {
        /!*console.log(`✅ Название города "${city}" есть в улице: "${street}"`);*!/
      } else {
        /!*console.log(
          `❌ Название города "${city}" отсутствует в улице: "${street}"`
        );*!/
        disableCheckoutBtn();
        load('change-delivery-area', 'area=outside', 'location=' + city);
      }
    }

    setTimeout(function () {
      isAutoCompleteFlagStart = true;
    }, 150);*/

    if (city && street && house) {
      getPlacePredictionsByInputs(city, street, house);
    }
  }

  /**
   * Check if place is inside Google Maps API:Polygon
   * @param place - place of Google Maps API:place
   * @param polygon - polygon of Google Maps APILPolygon
   * @return boolean
   * **/
  function checkPointInsidePoly(place, polygon) {
    return google.maps.geometry.poly.containsLocation(
      place.geometry.location,
      polygon
    );
  }

  /**
   * Take all inputs id's from form, and addEventListener @change
   * @callback formInputsListener
   * **/
  const inputIds = ['city-select', 'street', 'house'];
  inputIds.forEach((id) => {
    const input = document.getElementById(id);

    input.addEventListener('change', function (evt) {
      formInputsListener(citySelect);
    });
  });

  formInputsListener(citySelect);

  /*const howToDeliver = document.querySelector('#deliver-delivery');
  howToDeliver.addEventListener('change', function (evt) {
    if (evt.target.checked) {
      formInputsListener(citySelect);
    }
  });*/

  /*const allInputsIds = [
    ...inputIds,
    'first-name',
    'last-name',
    'phone-number',
    'name',
    'entrance',
    'floor',
    'apartment',
    'message',
  ];

  allInputsIds.forEach((id) => {
    const input = document.getElementById(id);

    input.addEventListener('change', function () {
      load('set-user-cookie', 'form:#pay-form');
    });
  });*/

  /**
   * Comment out for now
   * Position google marker always in center of map when drag ended
   * @callback getPlacePredictionsByMarkerMove
   * **/
  // google.maps.event.addListener(map, "dragend", function () {
  // 	marker.setPosition(this.getCenter()); // set marker position to map center
  // 	getPlacePredictionsByMarkerMove(
  // 		this.getCenter().lat(),
  // 		this.getCenter().lng()
  // 	);
  // });
}

window.hoverShowTrueMarker = hoverShowTrueMarker;
window.initMapFunc = initMapFunc;
window.initDeliveryZonesFunc = initDeliveryZonesFunc;
